<div fxLayout="column" fxLayoutAlign="center center" class="neutral-theme">
  <div class="title-container" fxLayout="column" fxLayoutAlign="center center">
    <h1>{{ evaluation?.title }}</h1>
  </div>
  @if (isLoadingOrSaving) {
    <div class="waiting-spinner">
      <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
    </div>
  }
  @if (!isLoadingOrSaving) {
    <div class="evaluation">
      <router-outlet></router-outlet>
    </div>
  }
</div>
